// import { useEffect, useState } from "react";
// import Swal from "sweetalert2";
// import axios from "axios";

// const EditBlogForm = (props) => {
//   const {
//     loadingCallback,
//     navigate,
//     setShowPaymentModal,
//     setShowModal,
//     isOpen,
//     title,
//     //setWarningMessage,
//     type,
//     refetch,
//     blog,
//     notify,
//     getBlogList
//   } = props;

//   const token = localStorage.getItem("token");

//   const [image, setImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState("");
//   const [formData, setFormData] = useState({
//     title: blog.title,
//     description: blog.description,
//     image: blog.image,
//     status: blog.status

//   });
//   const handleImageChange = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImage(file);
//       await uploadImage(file);
//     }
//   };

//   const uploadImage = async (file) => {
//     try {
//       const formImageData = new FormData();
//       formImageData.append("file_name", file);

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}file-upload`,
//         formImageData,
//         {
//           headers: {
//             authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       console.log("Image uploaded successfully:", response.data.path);
//       setFormData((prev) => ({ ...prev, image: response.data.path }));
//     } catch (error) {
//       console.error("Error uploading image:", error);
//       //alert("Failed to upload image.");
//       notify(error, "error");

//     }
//   };

//   const handleUpdate = async () => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}update-latest-blog/${blog.id}`,
//         formData,
//         {
//           headers: {
//             authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log("Blog updated successfully:", response.data);
//       //alert("Blog updated successfully!");
//       getBlogList();
//       notify(response.data.message, "success");
//     } catch (error) {
//       console.error("Error updating blog:", error);
//       //alert("Failed to update blog.");
//       notify(error, "error");
//     }
//   };

//   return (
//     <div className="duration-500 w-[3/4] h-[3/4]">
//       <div className="w-full relative">
//         <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
//           Title
//         </label>
//         <input
//           type="text"
//           name="title"
//           placeholder="Title"
//           value={formData.title}
//           onChange={(e) =>
//             setFormData({
//               ...formData,
//               title: e.target.value,
//             })
//           }
//           className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
//         />
//       </div>
//       <div className="flex flex-col ">
//         <div className="w-full relative mt-2">
//           <label className="absolute font-nunito text-xs text-[#102048]  left-[12px] top-[-7px] bg-white px-1 font-semibold">
//             Description
//           </label>
//           <textarea
//             type="text"
//             name="description"
//             value={formData.description}
//             onChange={(e) =>
//               setFormData({
//                 ...formData,
//                 description: e.target.value,
//               })
//             }
//             placeholder="Description"
//             className="input input-bordered border-[#C1CFEF] border-[1px] focus:outline-none  w-full  h-20 pt-2 rounded-xl bg-white resize-none"
//           />
//         </div>

//         <div className="flex flex-col">
//           <div className="w-full relative mt-2 md:pl-3">
//             <input type="file" accept="image/*" onChange={handleImageChange} />
//             {formData.image && (
//               <img
//                 src={formData.image}
//                 alt="Preview"
//                 className="w-32 h-32 mt-2"
//               />
//             )}
//           </div>
//         </div>

//         <div className="flex">
//           <div className="w-full relative mt-2 md:pl-3">
//             <input
//               checked={formData.status === 1}
//               type="checkbox"
//               id="product"
//               name="have_variant"
//               //checked={formData?.status ? formData?.status : 1} // Bind to the boolean value in `formData`
//               className="rounded-[6px]"
//               onChange={(e) =>
//                 setFormData({
//                   ...formData,
//                   status: e.target.checked ? 1 : 0,
//                 })
//               } // Use the updated `handleChange` function
//             />
//             <span className="text-[#91919F] ml-2 ">Active Status</span>
//           </div>{" "}
//         </div>

//         <div>
//           <button
//             onClick={handleUpdate}
//             className="cursor-pointer w-full mt-4 bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
//           >
//             Done
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default EditBlogForm

import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const EditBlogForm = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    type,
    refetch,
    blog,
    notify,
    getBlogList,
  } = props;

  const token = localStorage.getItem("token");

  const [image, setImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    title: blog.title || "",
    description: blog.description || "",
    image: blog.image || "",
    status: blog.status || 0,
  });

  useEffect(() => {
    if (blog) {
      setFormData({
        title: blog.title || "",
        description: blog.description || "",
        image: blog.image || "",
        status: blog.status || 0,
      });
    }
  }, [blog]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      await uploadImage(file);
    }
  };

  const uploadImage = async (file) => {
    setUploading(true);
    try {
      const formImageData = new FormData();
      formImageData.append("file_name", file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}file-upload`,
        formImageData,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      setFormData((prev) => ({ ...prev, image: response.data.path }));
      notify("Image uploaded successfully!", "success");
    } catch (error) {
      notify("Image upload failed", "error");
    } finally {
      setUploading(false);
    }
  };

  const handleUpdate = async () => {
    if (!formData.title || !formData.description) {
      notify("Title and Description are required", "error");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}update-latest-blog/${blog.id}`,
        formData,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      notify(response.data.message, "success");
      getBlogList();
      setShowModal(false);
    } catch (error) {
      notify("Failed to update blog.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Title
        </label>
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              title: e.target.value,
            }))
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>

      <div className="w-full relative mt-2">
        <label className="absolute font-nunito text-xs text-[#102048]  left-[12px] top-[-7px] bg-white px-1 font-semibold">
          Description
        </label>
        <ReactQuill
          theme="snow"
          value={formData.description}
          onChange={(value) =>
            setFormData((prev) => ({
              ...prev,
              description: value,
            }))
          }
          className="mb-2 bg-white rounded-xl"
        />
      </div>

      <div className="flex flex-col">
        <div className="w-full relative mt-2 md:pl-3">
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {uploading && (
            <p className="text-sm text-blue-500 mt-2">Uploading image...</p>
          )}
          {formData.image && (
            <img
              src={formData.image}
              alt="Preview"
              className="w-32 h-32 mt-2 rounded"
            />
          )}
        </div>
      </div>

      <div className="flex">
        <div className="w-full relative mt-2 md:pl-3">
          <input
            checked={formData.status === 1}
            type="checkbox"
            id="product"
            name="have_variant"
            className="rounded-[6px]"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                status: e.target.checked ? 1 : 0,
              }))
            }
          />
          <span className="text-[#91919F] ml-2 ">Active Status</span>
        </div>
      </div>

      <div>
        <button
          onClick={handleUpdate}
          disabled={isSubmitting}
          className={`cursor-pointer w-full mt-4 ${
            isSubmitting ? "bg-gray-400" : "bg-[#3559b3] hover:bg-[#034AFF]"
          } py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg`}
        >
          {isSubmitting ? "Updating..." : "Done"}
        </button>
      </div>
    </div>
  );
};

export default EditBlogForm;
